// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"7348fedd","53":"bbcd2445","82":"fceaae47","84":"0267f7e6","180":"7348fedd","237":"7348fedd","467":"7348fedd","595":"92dc08e8","718":"7348fedd"}[chunkId] + ".chunk.css";
};